import React, { useEffect, useRef } from 'react';
var VeltCommentThread = function (props) {
    var annotationId = props.annotationId, annotation = props.annotation, onCommentClick = props.onCommentClick, darkMode = props.darkMode, variant = props.variant, shadowDom = props.shadowDom, dialogVariant = props.dialogVariant, fullExpanded = props.fullExpanded;
    var ref = useRef();
    var onCommentClickRef = useRef(onCommentClick);
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        var element;
        var handleCommentClick = function (event) {
            if (onCommentClickRef.current) {
                onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onCommentClick', handleCommentClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onCommentClick', handleCommentClick);
            }
        };
    }, []);
    return (React.createElement("velt-comment-thread", { ref: ref, "annotation-id": annotationId, annotation: annotation ? JSON.stringify(annotation) : undefined, variant: variant, "dialog-variant": dialogVariant, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "full-expanded": [true, false].includes(fullExpanded) ? (fullExpanded ? 'true' : 'false') : undefined }));
};
export default VeltCommentThread;
